// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3LbAM","header":"MessagesList_header__3LETv","chat":"MessagesList_chat__3qppO"};